import AlertConfirm from "../../components/ConfirmationAler/AlertConfirm";
import TaraConfirmModal from "../../components/TaraConfirmModal/TaraConfirmModal";
import { configAction } from "../../store/config/slice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { LoginSteps, ModalStep } from "../../types/config";
import LoginModal from "../login/LoginModal";
import "./ModalGeneral.css";
const ModalLayout = () => {
  const dispatch = useAppDispatch();
  const { modalStep } = useAppSelector((state) => state.config);
  const handleCloseModal = function () {
    dispatch(configAction.setModalStep(ModalStep.DEFAULT));
  };
  const handleLogout = function () {
    localStorage.removeItem("banimodeUserProd");
    dispatch(configAction.setToken(""));
    dispatch(configAction.setLoginStep(LoginSteps.PHONE));
    handleCloseModal();
  };
  return (
    <>
      <LoginModal
        onClose={handleCloseModal}
        isModal={modalStep === ModalStep.LOGIN}
      />
      <AlertConfirm
        onClose={handleCloseModal}
        onConfirm={handleLogout}
        title="می‌خوای خارج بشی؟"
        btnText="خروج"
        isModal={modalStep === ModalStep.LOGOUT}
      />
    </>
  );
};
export default ModalLayout;
